var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 42Q6.55 42 5.8 39.9Q5.05 37.8 6.2 36.5L18.6 22.5V9H16Q15.4 9 14.95 8.55Q14.5 8.1 14.5 7.5Q14.5 6.9 14.95 6.45Q15.4 6 16 6H32Q32.6 6 33.05 6.45Q33.5 6.9 33.5 7.5Q33.5 8.1 33.05 8.55Q32.6 9 32 9H29.4V22.5L41.8 36.5Q43 37.85 42.225 39.925Q41.45 42 39.4 42ZM8 39H40L26.4 23.6V9H21.6V23.6ZM23.9 24Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabIcon);
export default __webpack_public_path__ + "static/media/lab-icon.467f0efa7cf2cabfcc18ce7e92eb302d.svg";
export { ForwardRef as ReactComponent };